export type Direction = 'ltr' | 'rtl';

/**
 * Plain string key — deliberately NOT Zustand's persist envelope. First paint reads this before any
 * store hydrates, so coupling it to a store's private serialization format would break on any
 * persist migration.
 */
export const LOCALE_STORAGE_KEY = 'management.locale';

/** Locales that render right-to-left. */
const RTL_LOCALES = new Set(['ar', 'he', 'fa', 'ur']);

export function directionForLocale(locale: string): Direction {
  return RTL_LOCALES.has(locale.split('-')[0] ?? '') ? 'rtl' : 'ltr';
}

export function readStoredLocale(): string | null {
  try {
    return globalThis.localStorage?.getItem(LOCALE_STORAGE_KEY) ?? null;
  } catch {
    // Storage can throw in private mode or when disabled by policy.
    return null;
  }
}

export function storeLocale(locale: string): void {
  try {
    globalThis.localStorage?.setItem(LOCALE_STORAGE_KEY, locale);
  } catch {
    // Non-fatal: the locale simply will not survive a reload.
  }
}

export function applyDocumentDirection(locale: string): Direction {
  const dir = directionForLocale(locale);
  const root = document.documentElement;
  root.lang = locale;
  root.dir = dir;
  return dir;
}
